import { render } from "./HoroUpload.vue?vue&type=template&id=296812a2"
import script from "./HoroUpload.vue?vue&type=script&lang=js"
export * from "./HoroUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__